export default {
    HEADER_HEIGHT: 40,
    HEADER_BORDER: 0,
    HEADER_BGCOLOR: '#542cd3',
    MAIN_COLOR: '#402499',

    // side bar
    SIDEBAR_WIDTH: 240,
    SIDEBAR_WIDTH_COLLAPSED: 80,
    SIDEBAR_BORDER_WIDTH: 5,
    SIDEBAR_BGCOLOR: '#f6f8fa',
    SIDEBAR_HOVER_BGCOLOR: 'transparent',
    SIDEBAR_SELECTED_BGCOLOR: 'transparent'
};
